import { authedAxios } from "../utils/customHttpHeader";

const base = "/support/ticket";

export const createTicket = (hotelId, payload) =>
  authedAxios().post(`${base}?hotelId=${hotelId}`, payload);

export const getTickets = (hotelId, params = {}) =>
  authedAxios().get(base, { params: { hotelId, ...params } });

export const getTicketById = (ticketId) =>
  authedAxios().get(`${base}/${ticketId}`);

export const addReply = (ticketId, payload) =>
  authedAxios().post(`${base}/${ticketId}/reply`, payload);
